export const validateGreaterThan = (value: number | undefined | null, minValue: number): boolean => {
	if (value === undefined || value === null || isNaN(value)) {
		return false;
	}

	return value > minValue;
};
